import { CreditCard, PlusCircle } from "lucide-react";
import { PaymentMethod } from "./Earnings";
import PaymentMethodCard from "./PaymentMethodCard";
import { CustomButton } from "@/components/ui/Buttons";

interface PaymentMethodsSectionProps {
  paymentMethods: PaymentMethod[];
  onAddBankAccount: () => void;
  onEditAccount: (method: PaymentMethod) => void;
  onDeleteAccount: (id: string) => void;
  isDeleting: boolean;
  maskAccountNumber: (accountNumber: string) => string;
}

const PaymentMethodsSection = ({
  paymentMethods,
  onAddBankAccount,
  onEditAccount,
  onDeleteAccount,
  isDeleting,
  maskAccountNumber,
}: PaymentMethodsSectionProps) => (
  <div className="w-full mx-auto mt-5">
    <div className="flex justify-between items-center mb-6">
      <h2 className="text-xl font-medium text-gray-800">Payment Methods</h2>
      <div className="flex items-center gap-3">
        <span className="px-3 py-1 bg-gray-100 text-gray-600 text-sm font-medium rounded-full flex items-center">
          3 maximum allowed
        </span>
        <CustomButton
          id="btn-add-bank-account"
          variant="outline"
          fontSize="12px"
          fontWeight="500"
          color="black"
          border="1px solid #D0D5DD"
          borderRadius="8px"
          padding="6px 12px"
          className="tracking-[-0.75%] leading-[18px] shadow-sm flex items-center gap-2"
          onClick={onAddBankAccount}
        >
          <PlusCircle size={14} /> Add new bank account
        </CustomButton>
      </div>
    </div>

    {paymentMethods.length === 0 ? (
      <div className="flex flex-col items-center justify-center py-12 bg-gray-50 rounded-lg border border-gray-100">
        <CreditCard size={32} className="text-gray-400 mb-3" />
        <p className="text-gray-600 mb-2">No payment methods found</p>
        <p className="text-sm text-gray-500">
          Add your first bank account to get started
        </p>
      </div>
    ) : (
      <div className="space-y-4">
        {paymentMethods.map((method) => (
          <PaymentMethodCard
            key={method._id}
            method={method}
            onEditAccount={onEditAccount}
            onDeleteAccount={onDeleteAccount}
            isDeleting={isDeleting}
            maskAccountNumber={maskAccountNumber}
          />
        ))}
      </div>
    )}
  </div>
);
export default PaymentMethodsSection;
